<template>
  <div>
    <b-input-group :prepend="currencyPrepend" :append="currentField.append ? currentField.append : ''">
          <b-form-input
            v-model="number"
            :name="storeInArray ? `formData${storeInArray}[${currentField.tagname}]` : `formData[${currentField.tagname}]`"
            :placeholder="currentField.placeholder"
            v-bind="attributesBinding"
            controls-position="left"
            :class="classes"
            >
            </b-form-input>

        </b-input-group>
        <span class="invalid-feedback" role="alert" v-if="error">
            <strong>{{ error }}</strong>
        </span>
  </div>
</template>


<script>
export default {
  name: 'NumberInput',
  props: ['currentField', 'storeInArray', 'value', 'error', 'currency'],
  data() {
    return {
      number: this.value ? this.value : ''
    }
  },

  watch: {
    value (value) {
      this.number = value ?? ''
    },

    number(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value,
      })
    }
  },

  computed: {

    classes () {
      var values = [];
      if (this.error) {
        values.push('is-invalid')
      }

      if (this.currentField.isCurrency) {
        values.push('toThousands')
      }

      return values.join(' ')
    },

    currencyPrepend() {
      if(this.currency && this.currentField.isCurrency) {
        return this.currency
      } else {
        return this.currentField.prepend ? this.currentField.prepend : ''
      }

    },


    attributesBinding() {
      var attr = {};
      attr.disabled = this.currentField.disabled;
      attr.step = this.currentField.step;
      attr['step-strictly'] = this.currentField.stepStrictly;
      attr['type'] = this.currentField.isCurrency ? "text" : "number";
      if (this.currentField.hasMinValue) {
        attr.min = this.currentField.min;
      }
      if (this.currentField.hasMaxValue) {
        attr.max = this.currentField.max;
      }
      return attr;
    }
  }
}
</script>
